import type { SearchAttributes, SearchQuery } from "@/lib/types/search"
import type { SelectContentEvent } from "@/platform/observability/analytics/v2/types/google"

const FILTER_CONTENT_IDS: [keyof SearchQuery, string][] = [
  ["priceMin", "price"],
  ["priceMax", "price"],
  ["inStockOnly", "in_stock"],
  ["categories", "category"],
  ["collections", "collection"],
]

const sameValues = (left: string[] = [], right: string[] = []) => left.length === right.length && left.every((value, index) => value === right[index])

const changedAttributes = (before: SearchAttributes, after: SearchAttributes): string[] =>
  [...new Set([...Object.keys(before), ...Object.keys(after)])].filter((key) => !sameValues(before[key], after[key]))

export const describeQueryUpdate = (updates: Partial<SearchQuery>, current: SearchQuery): SelectContentEvent["params"][] => {
  const events: SelectContentEvent["params"][] = []

  if (updates.sort !== undefined) events.push({ content_type: "sort", content_id: updates.sort })

  const reported = new Set<string>()
  for (const [key, contentId] of FILTER_CONTENT_IDS) {
    if (!(key in updates) || reported.has(contentId)) continue
    reported.add(contentId)
    events.push({ content_type: "filter", content_id: contentId })
  }

  if (updates.attributes) {
    for (const key of changedAttributes(current.attributes, updates.attributes)) events.push({ content_type: "filter", content_id: key })
  }

  return events
}
